import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import FiltersSidebar from '../../FiltersSidebar'
import Button from '../../ui/Button'
import { CollectService, FilterService } from '../../../services'

const FiltersButton = ({ collect }) => {
  const [collectData, setCollectData] = useState(null)
  const [currentFilters, setCurrentFilters] = useState({
    userFilterRules: [],
    variableFilters: []
  })
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    CollectService.getCollectData(collect.id)
      .then(setCollectData)
  }, [collect.id])

  useEffect(() => {
    FilterService.getFilters(collect.id)
      .then(filtersResponse => {
        setCurrentFilters({
          userFilterRules: filtersResponse.userFilterRules || [],
          variableFilters: filtersResponse.variableFilters || []
        })
      })
      .catch(() => {
        setCurrentFilters({
          userFilterRules: [],
          variableFilters: []
        })
      })
  }, [collect.id])

  const handleApplyFilters = useCallback(filters => FilterService.updateFilters(collect.id, filters)
    .then(() => {
      // Always use window.location.href to capture any URL changes made via replaceState
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)
      window.location.href = `${url.pathname}?${params.toString()}`
    }), [collect.id])

  const totalFilters = (currentFilters.userFilterRules || []).reduce((total, userFilterRule) => {
    const conditionsCount = userFilterRule.rule?.conditions?.length || 0
    return total + conditionsCount
  }, 0) + (currentFilters.variableFilters || []).length

  const handleOnClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  const handleOnOpen = useCallback(() => {
    setIsOpen(true)
  }, [])

  const getFilterStatusText = () => {
    if (totalFilters === 0)
      return 'Filtrer les données'

    if (totalFilters === 1)
      return '1 filtre actif'

    return `${totalFilters} filtres actifs`
  }

  const hasActiveFilters = totalFilters > 0

  return (
    <>
      <Button
        icon={hasActiveFilters ? 'exclamation-triangle' : 'filter'}
        variant={hasActiveFilters ? 'warning' : 'dark'}
        onClick={handleOnOpen}
      >
        {getFilterStatusText()}
      </Button>
      {Boolean(collectData) && <FiltersSidebar
        collect={collectData}
        currentFilters={currentFilters}
        isOpen={isOpen}
        onClose={handleOnClose}
        onApplyFilters={handleApplyFilters}
      />}
    </>
  )
}

FiltersButton.propTypes = {
  collect: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
}

export default FiltersButton
